import { paletteNames } from './Palette.types';

const loaderSizes = {
    small: 'small',
    regular: 'regular',
    large: 'large'
};
const defaultLoaderSize = loaderSizes.regular

const loaderIndicatiorColor = paletteNames;
const defaultLoaderIndicatiorColor = paletteNames.primary;

export {
    loaderSizes,
    defaultLoaderSize,
    loaderIndicatiorColor,
    defaultLoaderIndicatiorColor
}